import axios from "axios";
import store from "../store";
import constantes from "@/constantes";

const PREFIJO="/api/ClCt/";
const PREFIJO2="/api/PrmEmp/";


export default {
    calculoCuota(cotizacion,formulario){
        const dto = {
            id:formulario.banco.id,
            ndt1: formulario.valor,
            ndt2:  cotizacion.ndt3,//valor total del carro
            ndt3: formulario.banco.plan,
            ndt4: formulario.plazo.id,
            ndt5: formulario.banco.linea,
            dt1: formulario.banco.seguro,
            dt2: formulario.banco.producto,
            bdt1: false,
        };
        return axios.post(`${PREFIJO}VmClCt`,dto);
    },
    cuotas(){
        const dto = {
            dt1: constantes.Constantes.enumeraciones.linea,
            ndt1:  store.getters.getCotizacion.ndt6
        };
        return axios.post(`${PREFIJO2}VmPrtNtr`,dto);
    },

}
